import { type IFormFieldSchema } from '../types';
import { LIBRARY } from '../components/library-loader';

export const formatFormProps = (formProps: any) => {
  const normalizeCol = (col: any) =>
    typeof col === 'number' ? { span: col } : col;

  return {
    ...formProps,
    labelCol: normalizeCol(formProps.labelCol),
    wrapperCol: normalizeCol(formProps.wrapperCol),
  };
};

export const isDropable = (item: IFormFieldSchema<any>) => {
  return (
    LIBRARY.find(manifest => manifest.name === item['x-component'])
      ?.droppable || false
  );
};

export const stripDollarVariables = (expr: string) => {
  return expr.replace(/\$([a-zA-Z_][\w.]*)/g, (_, name) => name);
};

/**
 * Strips {{ }} braces from variable strings.
 * Example: "{{@.user.name}}" → "@.user.name"
 */
export const stripBraces = (value: string): string => {
  if (typeof value !== 'string') return value;
  return value.replace(/^\{\{|\}\}$/g, '').trim();
};

/**
 * Removes empty collections from the value.
 * Example: [{}] → undefined
 * Example: [{ id: 1 }] → [{ id: 1 }]
 * Example: {} → undefined
 * Example: [] → undefined
 */
export const stripEmptyCollections = (value: any): any => {
  if (Array.isArray(value)) {
    if (value.length === 0) return undefined;
    const cleaned = value
      .map(stripEmptyCollections)
      .filter(v => v !== undefined);

    return cleaned.length === 0 ? undefined : cleaned;
  }

  if (value !== null && typeof value === 'object') {
    const cleaned: Record<string, any> = {};
    for (const [k, v] of Object.entries(value)) {
      const c = stripEmptyCollections(v);
      if (c !== undefined) {
        cleaned[k] = c;
      }
    }

    return Object.keys(cleaned).length === 0 ? undefined : cleaned;
  }

  return value;
};
